//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'rb-tooltip',
  props: {
    pointer: {
      type: String,
      default: 'bottom', // options: ['top', 'right', 'bottom', 'left']
    },
    color: {
      type: String,
      default: 'grey', // options: ['grey', 'black', 'white', 'red']
    },
    fixed: {
      type: Boolean,
      default: false,
    },
    tooltipIsVisible: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isLightTheme() {
      return this.color === 'white'
        ? 'common__icon--close-side-panel'
        : 'common__icon--close-side-panel-light'
    },
  },
  watch: {
    tooltipIsVisible(value) {
      if (value === true) {
        this.focusCloseButton()
      }
    },
  },
  methods: {
    onTooltipClose() {
      this.$emit('closed')
    },
    focusCloseButton() {
      this.$refs.closeButton.focus()
    },
  },
}
